module.exports = __webpack_public_path__ + "ede963f908fbed4c6e08a33b5d90e5fe.png";